import cn from 'classnames';
import { Panel } from 'ht-styleguide';
import { TPlanFeatured, TPlansInfo } from 'src/types/plans.types';
import HighlightTab from '../HighlightTab';
import PlanInfo from '../PlanInfo';
import SelectPlanButton from '../SelectPlanButton';
import BenefitBlock from '../BenefitBlock';
import styles from './carousel.module.scss';

type PlanCardProps = {
  addToCart: BaseAnyFunction;
  billingCycle: string;
  planInfo: TPlansInfo;
  planButtonLabel?: string;
  usePlaceholder?: boolean;
};
const PlanCard = ({ addToCart, billingCycle, planInfo, planButtonLabel, usePlaceholder = true }: PlanCardProps) => {
  const { id, benefits } = planInfo[billingCycle] || {};
  const { featured } = planInfo as TPlanFeatured;
  const buttonProps = {
    label: planButtonLabel,
    addToCart: () => addToCart({ planId: id }),
  };

  return (
    <div className={styles.planCardOuterContainer}>
      {usePlaceholder && <HighlightTab isPlaceholder={!featured} />}
      <Panel className={cn('paddingY-medium1 paddingX-small2', styles.planCardContainer)} heavyShadow>
        <PlanInfo billingCycle={billingCycle} planInfo={planInfo} />
        <SelectPlanButton {...buttonProps} className="marginTop-small2 marginBottom-medium" />
        <div className={styles.benefitBlocksContainer}>
          {Array.isArray(benefits) &&
            benefits.map((benefit, i) => (
              <BenefitBlock
                benefitInfo={benefit}
                key={i}
                containerClass={i ? 'paddingTop-small2' : ''}
                showCheckmark
                checkmarkClass={styles.checkmarkIcon}
              />
            ))}
        </div>
        <SelectPlanButton {...buttonProps} className="marginTop-medium" />
      </Panel>
    </div>
  );
};

export default PlanCard;
